import { render, staticRenderFns } from "./verification-loader.vue?vue&type=template&id=3da44434&"
import script from "./verification-loader.vue?vue&type=script&lang=ts&"
export * from "./verification-loader.vue?vue&type=script&lang=ts&"
import style0 from "./verification-loader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports